import {
	ORDER_SITUATION_FINAL,
	POST_PAYMENT_TIMINGS,
} from '../../../constants/post-payment.constants'

// Decisoes do pos-clique, fora dos componentes para poderem ser testadas sem
// montar React.

/**
 * Qual mensagem o modal de erro do checkout mostra?
 *
 * - A da API, quando ela explica a recusa (cartao recusado, poltrona tomada).
 * - Nenhuma (null = o componente usa o texto padrao da loja) quando:
 *   - o Hub devolveu Order.AwaitingReservation: o texto dele manda "nao refazer
 *     a compra", e o bug 8067 tirou esse aviso do site;
 *   - o erro e do proprio axios (timeout, rede, status sem corpo): a mensagem
 *     dele e tecnica ("timeout of 80000ms exceeded");
 *   - o Hub respondeu 5xx: o pedido pode ter sido criado e cobrado, e o texto
 *     dele ("Ocorreu um erro inesperado", "Timeout ao chamar MuviFlex") nao
 *     pede para conferir Minhas Compras antes de tentar de novo.
 *
 * @param {*} error Erro do axios, ou Error lancado no 200 OK com success:false
 * @return {string|null} mensagem a mostrar, ou null para o texto padrao
 */
export function checkoutErrorMessage(error) {
	if (!error) return null

	const data = error.response && error.response.data

	if (data && data.errorCode === 'Order.AwaitingReservation') return null
	if (error.response && error.response.status >= 500) return null
	if (data && data.message) return data.message

	// Erros do axios carregam o config do request; o Error do success:false nao.
	if (error.config) return null

	return error.message || null
}

/**
 * Spec 062: o Hub recusou o checkout porque o total do pacote de valores difere do que a tela mostrou
 * (409 `Checkout.PriceChanged`). Nada foi cobrado; o site mostra a mensagem do servidor e recarrega os valores.
 * @param {*} error Erro do axios
 * @return {boolean}
 */
export function isPriceChangedError(error) {
	const response = error && error.response
	return !!response && response.status === 409 && !!response.data && response.data.errorCode === 'Checkout.PriceChanged'
}

/**
 * Estado da tela "emitindo": quanto erro seguido tolerar e quando parar de
 * consultar.
 *
 * Antes da spec 056 esta tela tinha UM caminho de erro: a primeira consulta que
 * falhasse abria um modal afirmando que a compra nao seria cobrada. Um soluco de
 * rede durante uma emissao saudavel bastava.
 */
export class EmissionProgress {
	/** @param {object} timings Sobrescreve os tempos (testes); default = producao */
	constructor(timings) {
		this.timings = Object.assign({}, POST_PAYMENT_TIMINGS, timings)
		this.consecutiveErrors = 0
		this.gaveUp = false
		this.paymentSeenAtMs = null
		this.invited = false
	}

	/**
	 * O Hub ja tem o pagamento do pedido? Spec 056 (T125, contrato da parte 3
	 * §8.1): `paymentReceived` e opcional — ausente ou nulo (pedido so do legado,
	 * Hub antigo) vale como "nao sabemos", e o site segue como antes.
	 */
	static isPaymentReceived(order) {
		return !!order && order.paymentReceived === true
	}

	/**
	 * Registra a consulta do pedido para o convite do Pix pago. So o Pix conta:
	 * cartao e Muvicard ja chegam pagos a esta tela e nao ganham convite aqui.
	 * O relogio dos 240s comeca na PRIMEIRA consulta que viu o pagamento — antes
	 * disso o cliente ainda esta diante do QR Code.
	 */
	registerOrder(order, nowMs, isPix) {
		if (!isPix || this.paymentSeenAtMs !== null) return
		if (EmissionProgress.isPaymentReceived(order)) this.paymentSeenAtMs = nowMs
	}

	/**
	 * Chegou a hora do convite "a emissao esta em andamento" (Pix pago ha 240s,
	 * pedido ainda sem desfecho)? Devolve true uma vez so; o polling NAO para.
	 */
	shouldInvite(nowMs) {
		if (this.invited || this.paymentSeenAtMs === null) return false
		if (nowMs - this.paymentSeenAtMs < this.timings.EMISSION_INVITE_AFTER_MS)
			return false
		this.invited = true
		return true
	}

	/** Uma consulta falhou. Devolve true quando a tela deve desistir de consultar. */
	registerError() {
		this.consecutiveErrors += 1
		this.gaveUp =
			this.consecutiveErrors >= this.timings.EMISSION_MAX_CONSECUTIVE_ERRORS
		return this.gaveUp
	}

	/** Uma consulta respondeu: zera a contagem de erros seguidos. */
	registerSuccess() {
		this.consecutiveErrors = 0
	}

	/**
	 * A situacao devolvida pelo Hub encerra a espera? "Concluído" e "Cancelado"
	 * sempre encerraram; a spec 056 acrescenta "Em análise" — o desfecho
	 * automatico acabou e o que falta e acao humana, entao ficar consultando so
	 * mantem o cliente numa tela de carregamento eterna.
	 */
	static isFinalSituation(status) {
		return ORDER_SITUATION_FINAL.indexOf(status) !== -1
	}
}
